import BookCard from 'web/BookCard/BookCard'
import { useMagazine } from 'hooks/useMagazine'
import { Button, Spin, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { SEARCH } from 'configs/path'
import { IBook } from 'models/book'
import { bindParams } from 'utilities/helpers'
import { useAppSelector } from 'hooks'
import { useEffect, useState } from 'react'
const HomePC = () => {
  const { magazinesPuchase, hasMore, loadMore, loading, search_header, magazineDigital, decodeURIComponentSafely } = useMagazine()
  const location = useLocation()
  const app = useAppSelector((s) => s.app.app_id)
  const { t } = useTranslation()
  const [listMagazine, setListMagazine] = useState<IBook[]>([])

  useEffect(() => {
    setListMagazine([...magazineDigital, ...magazinesPuchase.filter((magazine) => magazine.isDisplay)])
  }, [magazinesPuchase, magazineDigital])

  return (
    <div className="home-page-pc-container">
      <Typography className="text-all">
        {decodeURIComponentSafely(location.pathname) === bindParams(SEARCH, { app: app})
          ? `${t('search_result')} : ${search_header}`
          : t('all')}
      </Typography>

      <div className="home-page-pc-content">
        {listMagazine.length > 0 &&
          listMagazine.map((pdf: IBook, index) => {
            return <BookCard pdf={pdf} id={pdf.id} key={index} />
          })}
      </div>

      {listMagazine.length === 0 && !loading && (
        <Typography style={{ marginLeft: '1rem' }}>
          {decodeURIComponentSafely(location.pathname) === bindParams(SEARCH, { app: app})
            ? t('no_data_list_magazine')
            : t('no_data')}
        </Typography>
      )}
      {loading && (
        <div className="loading-container">
          <Spin />
        </div>
      )}
      {hasMore && !loading && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Button onClick={loadMore} type="primary">
            {t('next_page', { page: 20 })}
          </Button>
        </div>
      )}
    </div>
  )
}

export default HomePC
